import { Container } from "@material-ui/core"
import BitPage from "components/PurchasePage/Preview/Payment/BitPage"
import styled from "styled-components"

const StyledWrapper = styled(Container)`
  padding-right: 60px;
  margin-top: 80px;
  padding-left: 120px;
  padding-bottom: 100px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 66px;
    padding-left: 16px;
    padding-right: 16px;
  }
`

const Bit = () => {
  return (
    <StyledWrapper>
      <BitPage />
    </StyledWrapper>
  )
}
export default Bit
